import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";

const TRACKING_CATEGORY = "industry taxonomy v2";

/**
 * Kept out of the demo-mode service: its close event is modelled as `demo mode / exit`, which would be a
 * false report for a user who is opted in and therefore never in a demo.
 */
const createIndustryTrackingService = (track: TrackFn) => {
    return {
        trackLaunchBannerCtaClick() {
            track(TRACKING_CATEGORY, "click", "launch banner cta");
        },
        trackLaunchBannerDismiss() {
            track(TRACKING_CATEGORY, "click", "launch banner dismiss");
        },
        trackImpactReportOpen(source: "banner" | "email" = "banner") {
            track(
                TRACKING_CATEGORY,
                "click",
                source === "email" ? "impact report open from email" : "impact report open",
            );
        },
        trackImpactReportEnroll() {
            track(TRACKING_CATEGORY, "click", "impact report enroll");
        },
        trackImpactReportEnrollRetry() {
            track(TRACKING_CATEGORY, "click", "impact report enroll retry");
        },
        trackImpactReportDismiss() {
            track(TRACKING_CATEGORY, "click", "impact report dismiss");
        },
        trackImpactReportContactUs() {
            track(TRACKING_CATEGORY, "click", "impact report contact us");
        },
        /** A settled state, not a click, so the account-migration funnel can measure completion. */
        trackImpactReportEnrollSuccess() {
            track(TRACKING_CATEGORY, "view", "impact report enrolled");
        },
        trackImpactReportViewLeadGeneration() {
            track(TRACKING_CATEGORY, "click", "enroll success view lead generation");
        },
        trackImpactReportCrmSettings() {
            track(TRACKING_CATEGORY, "click", "enroll success crm settings");
        },
    };
};

export default createIndustryTrackingService;
